import React from 'react';
import { Box, IconButton, Modal, styled, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SelectBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.paper,
  boxShadow: 24,
  overflow: 'scroll',
  color: 'black',
  height: '80%',
  borderRadius: '5px',
  padding: 10,
  p: 4,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '100%',
    padding: 10,
  },
}));
const AffiliatesTerms = ({ handleClose, open }) => {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <SelectBox>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} />
          <Box>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Typography variant="h5" sx={{ textAlign: 'center' }}>
          SELECT INNOVATIONS, INC. AFFILIATE MARKETING PROGRAM TERMS
        </Typography>
        <Typography>
          <b>1. Introduction:</b> These terms outline the agreement between Select Innovations, Inc. (&quot;the Company&quot;) and the Affiliate, relating to the Company's Affiliate Marketing Program.
        </Typography>
        <Typography>
          <b>2. Affiliate Obligations:</b> Affiliates are obliged to conduct themselves in a manner that is ethical, professional and in accordance with all applicable laws and regulations.
        </Typography>
        <Typography>
          <b>3. Keyword Bidding:</b> Affiliates are not permitted to engage in keyword bidding for any reason. Keyword bidding includes, but is not limited to, any attempt to rank higher in search engine results by bidding on relevant
          keywords.
        </Typography>
        <Typography>
          <b>4. Commissionable Conversions:</b> The Affiliate will receive a baseline commission of $50 for every commissionable conversion, defined as a user who becomes an approved, paid member of Select through the Affiliate's
          promotional efforts. The Company reserves the right to reject any conversion that does not meet the Company's standards or compliance requirements.
        </Typography>
        <Typography>
          <b>5. Affiliate Dashboard:</b> The Affiliate will have access to the Company's affiliate dashboard, where they can monitor sign-ups and traffic resulting from their promotional efforts.{' '}
        </Typography>
        <Typography>
          <b>6. Complimentary Membership:</b> In addition to the commission, the Affiliate will receive a complimentary Select membership, valued at $450 per year. This complimentary membership cannot be transferred, substituted or
          exchanged for monetary compensation.
        </Typography>
        <Typography>
          <b>7. Payment Terms:</b> Commissions are paid out on a monthly basis. A two-week grace period is allowed after each payment to accommodate any refunds. Any commission corresponding to a membership that is refunded within this
          two-week grace period will be deducted from the next commission payment.
        </Typography>
        <Typography>
          <b>8. Termination:</b> The Company reserves the right to terminate this agreement at any time if the Affiliate fails to comply with any of the terms outlined in this agreement, or at the Company's discretion.
        </Typography>
        <Typography>
          <b>9. Changes to Terms:</b> The Company may, at any time, choose to edit, add or delete portions of these terms. Affiliates will be notified of any changes and it will be their responsibility to review these changes and decide
          whether they wish to continue participating in the program under the updated terms.
        </Typography>
        <Typography>
          <b>10. Acceptance of Terms:</b> By participating in the Company's Affiliate Marketing Program, the Affiliate acknowledges that they have read, understood and agreed to be bound by these terms.
        </Typography>
        <Typography>
          <b>11. Confidentiality:</b> During the term of this Agreement, the Affiliate may receive information regarding the Company, its affiliates, or its business practices that is confidential and not generally known by the public
          (&ldquo;Confidential Information&rdquo;). The Affiliate agrees that all Confidential Information remains the sole property of the Company, and the Affiliate has no interest in such information. The Affiliate will use Confidential
          Information only as necessary to fulfill its obligations under this Agreement and will not disclose any Confidential Information to any third party without the prior written consent of the Company. Upon termination of this
          Agreement, the Affiliate will return all Confidential Information to the Company and will not use or disclose any Confidential Information. This clause shall survive the termination of the Agreement.
        </Typography>
        <Typography>
          <b>12. Non-Disparagement:</b> The Affiliate agrees that they will not at any time during the agreement and thereafter make public statements or representations, or cause others to make such statements or representations that
          defame, disparage or in any way criticize the personal and/or business reputation, practices, or conduct of the Company, its employees, directors, or officers. The Affiliate acknowledges and agrees that this prohibition extends to
          public statements or representations made online, including but not limited to social media platforms and forums, blogs, and review sites.
        </Typography>
        <Typography>
          <b>13. Marketing Material Approval and Brand Guidelines Compliance:</b> The Affiliate agrees to only use promotional materials that have been approved in advance by the Company. The Affiliate agrees to submit all promotional
          materials to the Company for approval prior to use. The Affiliate will comply with the Company's brand guidelines, which will be provided to the Affiliate upon acceptance into the Affiliate Program. These guidelines may include,
          but are not limited to, instructions for using the Company's logos, trademarks, images, taglines, and other brand assets. The Company reserves the right to request changes or deny approval of materials that do not comply with the
          brand guidelines or that the Company otherwise deems unsuitable for any reason.
        </Typography>
        <Typography>
          <b>14. Right to Disclose:</b> The Affiliate grants the Company the right to disclose the existence and terms of this Agreement, including the identity of the Affiliate, in business materials, press releases, interviews,
          promotional materials, and other public communications. The Affiliate also gives consent to the Company to use the Affiliate&rsquo;s name, likeness, logo, URL, trademarks, trade names, legal names, and other identifiers used by
          the Affiliate, for the purpose of advertising, marketing, announcing, or otherwise publicizing the Affiliate's relationship with the Company.
        </Typography>
      </SelectBox>
    </Modal>
  );
};

export default AffiliatesTerms;
